import React from "react";
import {
  ReusableOnboardingMapButton,
  ReusableOnboardingButton,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../../store/validation/is-Empty";
import Switch from "react-switch";

export const HealthAndSenitationOthers = ({
  bigText,
  entryPointCheck,
  entryPointCheckHandler,
  smallText,
  primaryBigText,
  primarySmallText,
  otherHealth,
  selectedOtherHealth,
  primaryOtherHealth,
  onRestaurantSelectorArraySelector,
  onRestaurantsPrimarySelector,
  removeButton,
  onBackButtonClick,
  onNextButtonClick,
  displayNextButton,
}) => {
  return (
    <React.Fragment>
      <div className="col-12">
        <div className="row health_and_senitation_onboarding_main_div">
          <div className="col-9 col-sm-9 col-md-10 col-lg-10 col-xl-10 pl-0 health_and_senitation_onboarding_main_divone">
            <h5>
              Do you follow Health and Sanitation practices at the Entry Point?
            </h5>
            <p>Turn off this section if doesn’t applicable to your Business</p>
          </div>
          <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2 p-0 health_and_senitation_onboarding_main_divtwo">
            <Switch
              checked={entryPointCheck}
              onChange={entryPointCheckHandler}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#212121"
              onHandleColor="#59F832"
              handleDiameter={22}
              uncheckedIcon={false}
              checkedIcon={false}
              height={14}
              width={38}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>
        </div>
      </div>

      <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
        {entryPointCheck === true ? (
          <div>
            <div className="col-12 located-inside-heading-text">
              <h3 className="text-dark">{bigText}</h3>
              <p>{smallText}</p>
            </div>
            <div className="cuisine-main ">
              <div
                className={
                  otherHealth.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {otherHealth.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={onRestaurantSelectorArraySelector(icon, index)}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d10"} />
              </div>

              {/** */}
              {!isEmpty(selectedOtherHealth) ? (
                <h2 className="heading-title">
                  {primaryBigText}
                  <small
                    id="emailHelp"
                    className="form-text text-muted input-help-textnew"
                  >
                    {primarySmallText}
                  </small>
                </h2>
              ) : null}

              <div
                className="cuisine-main-padding-bottom mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selectedOtherHealth.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      icon._id === primaryOtherHealth._id
                        ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                        : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    displayPrimary={
                      icon._id === primaryOtherHealth._id ? true : false
                    }
                    onClick={onRestaurantsPrimarySelector(icon)}
                    displayRemove={true}
                    removeButtonClick={removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : null}
        <div className="onboarding-map-setup-screen-autodetect-button">
          {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            buttonType="button"
            onClick={onBackButtonClick}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass={`onboarding_button_link_reusable ${
              errorChecker(selectedOtherHealth, primaryOtherHealth)
                ? "onboarding_button_link_reusable_gray ml-3"
                : "onboarding_button_link_reusable_red ml-3"
            }`}
            buttonText={displayNextButton === true ? "Save & Next" : "Next"}
            buttonType="button"
            disabled={errorChecker(selectedOtherHealth, primaryOtherHealth)}
            onClick={onNextButtonClick}
          />
          {/* </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

const errorChecker = (selectedOtherHealth, primaryOtherHealth) => {
  if (selectedOtherHealth.length === 0 || isEmpty(primaryOtherHealth)) {
    return true;
  } else {
    return false;
  }
};
